import axios from 'axios';

// Create an Axios instance
const axiosInstance = axios.create({
    // baseURL: process.env.VUE_APP_API_BASE_URL || 'https://api.example.com',
    // timeout: 10000,
    // headers: {
    //     'Content-Type': 'application/x-www-form-urlencoded',
    // },
});

// Add request interceptor (optional)
axiosInstance.interceptors.request.use(
    (config) => {
        return config;
    },
    (error) => Promise.reject(error)
);

const ERROR_MESSAGES = {
    SERVER_500: "System error. Please contact your tech team",
};

// Add response interceptor (optional)
axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
        const status = error.response?.status;

        if (/Error: Request failed with status code 419/i.test(error)) {
            window.location.reload();
        }

        switch (true) {
            // 5xx — server errors
            case status >= 500:
                axiosInstance._notify?.error(ERROR_MESSAGES.SERVER_500);
                break;
        }

        return Promise.reject(error);
    }
);

export default {
    install(Vue) {
        Vue.prototype.$axios = axiosInstance;

        if (Vue.prototype.$notify) {
            axiosInstance._notify = Vue.prototype.$notify;
        }
    },
};

// Export Axios instance for standalone use
export { axiosInstance };
